// extracted by mini-css-extract-plugin
export var container = "reserva-module--container--7Tv1u";
export var img = "reserva-module--img--T4bNO";
export var text = "reserva-module--text--uXx0N";